import './style/main.scss';
import './fa-solid.js';
import './fa-brands.js';
import './fontawesome.js';
import 'normalize.css';
import logoGrey from './images/R1P_Logo_Grey.png';
import r1plogo from './images/RouteOnePower@2x.png';
import whiteArrow from './images/ArrowDown.png';
import greyArrow from './images/ArrowGrey.png';
import hamImage from './images/HamburgerIcon@2x.png';
import closeImage from './images/CloseIcon@2x.png';
import bgImageOne from './images/スクリーンショット 2017-12-12 14.17.48.png';
import bgImageTwo from './images/スクリーンショット 2017-12-12 14.17.37.png';
import profileShacho from './images/Hattori_S.jpg';
import AOS from 'aos';
import '../node_modules/aos/dist/aos.css';
import $ from 'jquery';
import 'jquery-scrollify';
import 'jquery.easing';
import GoogleMapsLoader from 'google-maps';
import compData from './data/companies.json';
import timelineData from './data/timeline';
import verge from 'verge';
import Hammer from 'hammerjs';
import flexibility from 'flexibility';
import Modernizr from 'modernizr';


if (!document.documentElement.dataset &&
  (
    !Object.getOwnPropertyDescriptor(HTMLElement.prototype, 'dataset') ||
    !Object.getOwnPropertyDescriptor(HTMLElement.prototype, 'dataset').get
  )
) {
  const descriptor = {}

  descriptor.enumerable = true

  descriptor.get = function get () {
    const element = this
    const map = {}
    const attributes = this.attributes

    function toUpperCase (n0) {
      return n0.charAt(1).toUpperCase()
    }

    function getter () {
      return this.value
    }

    function setter (name, value) {
      if (typeof value !== 'undefined') {
        this.setAttribute(name, value)
      } else {
        this.removeAttribute(name)
      }
    }

    for (let i = 0; i < attributes.length; i += 1) {
      const attribute = attributes[i]

      // This test really should allow any XML Name without
      // colons (and non-uppercase for XHTML)

      if (attribute && attribute.name && (/^data-\w[\w-]*$/).test(attribute.name)) {
        const name = attribute.name
        const value = attribute.value

        // Change to CamelCase

        const propName = name.substr(5).replace(/-./g, toUpperCase)

        Object.defineProperty(map, propName, {
          enumerable: descriptor.enumerable,
          get: getter.bind({ value: value || '' }),
          set: setter.bind(element, name)
        })
      }
    }
    return map
  }

  Object.defineProperty(HTMLElement.prototype, 'dataset', descriptor)
}

function navigation() {
  const sections = document.getElementsByTagName('section');
  const element = document.createElement('nav');
  const burger = document.createElement('div');
  const menu = document.createElement('div');

  menu.classList.add('menu');

  const items = [ 
    'Home',
    'Introduction',
    'Companies',
    'Mission',
    'Power',
    'Team',
    'History',
    'Mentor',
    'Company',
    'Group',
    'Access',
  ]

  items.forEach(function(item) {
    let menuItem = document.createElement('a');
    menuItem.innerHTML = item;
    menuItem.href = '#' + item.toLowerCase();
    menuItem.addEventListener('click', function(ev) {
      toggleMenu();
      if ( !verge.mq('(max-width: 768px)') ) {
        ev.preventDefault();
        const target = ev.target.innerHTML;
        $.scrollify.move('#' + target);
      }
    });
    menu.appendChild(menuItem);
  });
    
  let ham = new Image();
  ham.src = hamImage;
  let close = new Image();
  close.src = closeImage;
  close.classList.add('invisible');
  close.classList.add('close');

  burger.classList.add('burger');
  burger.appendChild(ham);
  burger.appendChild(close);

  function toggleMenu(el) {
    element.classList.toggle('active');
    ham.classList.toggle('invisible');
    close.classList.toggle('invisible');

    for (const section of sections) {
      section.classList.toggle('blurry');
    }
    element.addEventListener('click', closeMenu, {'capture': true, 'once': true});
  }

  function closeMenu(ev) {
    if (element == event.target) {
      element.classList.remove('active');
      close.classList.add('invisible');
      ham.classList.remove('invisible');
      for (const section of sections) {
        section.classList.remove('blurry');
      }
    }
  }

  ham.addEventListener('click', toggleMenu);
  close.addEventListener('click', toggleMenu);

  element.appendChild(burger);
  burger.appendChild(menu);

  return element;
}

function home() {
  const element = document.createElement('section');
  element.classList.add('full-height');
  element.classList.add('home');
  element.classList.add('white-bg');
  element.dataset.sectionName = 'Home';
  element.id = 'home';

  let logo = new Image();
  logo.src = logoGrey;
  logo.classList.add('logo');
  logo.dataset.aos = 'zoom-in';
  logo.dataset.aosDelay = 300;

  let arrow = new Image()
  arrow.src = greyArrow;
  arrow.addEventListener('click', function() {
    $.scrollify.next();
  });
  arrow.classList.add('arrow');

  element.appendChild(logo);
  element.appendChild(arrow);

  return element;
}

function intro() {
  const element = document.createElement('section');
  const header = document.createElement('h1');
  const text = document.createElement('p');
  
  header.innerHTML = 'The Human Power Station.';
  header.dataset.aos = 'fade-right';
  header.dataset.aosDelay = 300;
  text.innerHTML = 'We aspire to be a "growth enterprise" that prepares plans for the creation of new business making extensive use of mobile communications, breeds employment, and thereby provides from the continued growth of both businesses and human resources.';
  text.dataset.aos = 'fade-up';
  text.dataset.aosDelay = 500;

  element.appendChild(header);
  element.appendChild(text);
  element.classList.add('full-height');
  element.classList.add('intro');
  element.dataset.sectionName = 'Introduction';
  element.id = 'introduction';

  return element;
}

function companies() {
  const images = require.context('./logos', false, /\.png$/);
  const element = document.createElement('section');

  element.classList.add('full-height');
  element.classList.add('white-bg');
  element.classList.add('logos');

  let grid;

  if (Modernizr.cssgrid) {
    grid = document.createElement('div');
    grid.classList.add('columns');

    compData.forEach(function(company) {
      const box = document.createElement('a');
      box.classList.add('box');

      let logo = new Image();
      logo.src = images(company['file']);
      box.href = company['link'];
      box.appendChild(logo);
      if( !verge.mq('(min-resolution: 193dpi), (-webkit-min-device-pixel-ratio: 2.1)') ) {
        logo.addEventListener('load', e => {
          e.target.style.width = (e.target.naturalWidth / 2) + "px";
          e.target.style.height = (e.target.naturalHeight / 2) + "px";
        });
      } else {
        logo.addEventListener('load', e => {
          e.target.style.width = (e.target.naturalWidth / 4) + "px";
          e.target.style.height = (e.target.naturalHeight / 4) + "px";
        });
      }

      grid.appendChild(box);
    });
  } else {
    grid = document.createElement('table');
    grid.classList.add('columns');
    let counter = 0;
    let row;

    compData.forEach(function(company) {
      if ( (counter % 4) === 0 ) {
        row = document.createElement('tr');
        grid.appendChild(row);
      }

      const cell = document.createElement('td');
      const link = document.createElement('a');
      cell.appendChild(link);

      let logo = new Image();
      logo.src = images(company['file']);
      link.href = company['link'];
      link.appendChild(logo);

      if( !verge.mq('(min-resolution: 192dpi), (-webkit-min-device-pixel-ratio: 2)') ) {
        logo.addEventListener('load', e => {
          e.target.style.width = (e.target.naturalWidth / 2) + "px";
          e.target.style.height = (e.target.naturalHeight / 2) + "px";
        });
      } else {
        logo.addEventListener('load', e => {
          e.target.style.width = (e.target.naturalWidth / 4) + "px";
          e.target.style.height = (e.target.naturalHeight / 4) + "px";
        });
      }

      counter++;
      row.appendChild(cell);
    });
  }

  element.appendChild(grid);
  element.dataset.sectionName = 'Companies';
  element.id = 'companies';
  
  return element;
}

function mission() {
  const element = document.createElement('section');
  const container = document.createElement('div');
  const header = document.createElement('h1');
  const textOne = document.createElement('p');
  const textTwo = document.createElement('p');

  header.innerHTML = 'Mission.';
  textOne.innerHTML = 'その業界（Route）で、No. 1（One）を、目指す事業を支援し、新しいPowerを創造する。';
  textTwo.innerHTML = '22年前、私達は通信業界でナンバーワンを目指して創業しました。その道を極めた経験から、ライフスタイルに新しいPOWERを与える事業に対して様々な角度で支援することをミッションとしています。'
  header.dataset.aos = 'fade-right';
  textOne.dataset.aos = 'fade-left';
  textTwo.dataset.aos = 'fade-left';
  textOne.dataset.aosDelay = 300;
  textTwo.dataset.aosDelay = 300;

  container.appendChild(header);
  container.appendChild(textOne);
  container.appendChild(textTwo);

  element.appendChild(container);
  element.classList.add('full-height');
  element.classList.add('mission')
  element.dataset.sectionName = 'Mission';
  element.id = 'mission';

  return element;
}

function power() {
  const element = document.createElement('section');
  const container = document.createElement('div');
  const header = document.createElement('h1');
  const textOne = document.createElement('p');
  const textTwo = document.createElement('p');
  const textThree = document.createElement('p');

  header.innerHTML = 'Power.';
  header.dataset.aos = 'fade-left';
  textOne.innerHTML = 'POWER＝SEED（種）＋Nutrition（栄養）様々な出会いの中からその種は誕生します。やがて小さな芽が出て、それは枝となり、葉が生い茂り、気がつけば大きな樹木に。';
  textTwo.innerHTML = '種には様々な栄養が必要です。私たちはこれまでの経験から種の大切さと栄養の大切さ、両方を実感してきました。';
  textThree.innerHTML = '大きな樹木（POWER）が育てられるよう、ミッションを達成してまいります。';
  textOne.dataset.aos = 'fade-right';
  textOne.dataset.aosDelay = 300;
  textTwo.dataset.aos = 'fade-right';
  textTwo.dataset.aosDelay = 300;
  textThree.dataset.aos = 'fade-right';
  textThree.dataset.aosDelay = 300;

  container.appendChild(header);
  container.appendChild(textOne);
  container.appendChild(textTwo);
  container.appendChild(textThree);

  element.appendChild(container);
  element.classList.add('full-height');
  element.classList.add('power');
  element.id = 'power';
  element.dataset.sectionName = 'Power';

  return element;
}

function card(imageFile, yearText, titleText, text) {
  const card = document.createElement('div');
  const cardBody = document.createElement('div');
  const year = document.createElement('h2');
  const title = document.createElement('h3');
  const info = document.createElement('p');
  const cardFront = document.createElement('div');

  card.classList.add('card');
  card.classList.add('flipCard');
  cardFront.classList.add('card-face');
  cardFront.classList.add('card-front');
  cardBody.classList.add('card-body');

  let headerImage = new Image();
  headerImage.src = imageFile;

  year.innerHTML = yearText;
  title.innerHTML = titleText;
  info.innerHTML = text;

  cardBody.appendChild(year);
  cardBody.appendChild(title);
  cardBody.appendChild(info);

  cardFront.appendChild(headerImage);
  cardFront.appendChild(cardBody);

  card.appendChild(cardFront);

  return card;
}

function timeline() {
  const element = document.createElement('section');
  element.classList.add('full-height');
  element.classList.add('timeline');
  element.classList.add('white-bg');
  element.id = 'history';
  element.dataset.sectionName = 'History';

  const header = document.createElement('h1');
  header.innerHTML = 'History';
  element.appendChild(header);

  const root = document.createElement('div');
  root.classList.add('root');
  element.appendChild(root);

  const left = document.createElement('div');
  const right = document.createElement('div');
  const center = document.createElement('div');
  left.classList.add('left');
  center.classList.add('center');
  right.classList.add('right');

  center.innerHTML = '&nbsp;';
  if ( !verge.mq('(max-width: 768px)') ) {
    root.appendChild(left);
  }
  root.appendChild(center);
  root.appendChild (right);

  const images = require.context('./images/timeline', false, /\.(png|svg)$/);
  timelineData.forEach((event) => {
    let column = event.column;
    if ( verge.mq('(max-width: 768px)') ) {
      column = 'right';
    }
    const image = images(event.image);
    const newCard = card(image, event.date, event.title, event.text);
    newCard.id = "event" + event.id;
    newCard.dataset.aos = 'fade-' + column;
    newCard.dataset.aosAnchorPlacement = "top-center"
    column === 'left' ? left.appendChild(newCard) : right.appendChild(newCard);
    const marker = images('./' + column + '-marker.svg');
    let markerImage = new Image();
    markerImage.dataset.aos = 'zoom-in-' + column;
    markerImage.dataset.aosAnchorPlacement = "top-center"
    markerImage.src = marker;
    markerImage.dataset.aosAnchor = '#event' + event.id;
    markerImage.classList.add('marker');
    markerImage.classList.add(column);
    center.appendChild(markerImage);
  });
  return element
}

function shacho() {
  const element = document.createElement('section');
  const card = document.createElement('div');
  const cardBody = document.createElement('div');
  const cardFooter = document.createElement('div');
  const title = document.createElement('p');
  const nameKanji = document.createElement('h2');
  const nameRomaji = document.createElement('h3');
  const twitter = document.createElement('a');
  const facebook = document.createElement('a');
  const blogger = document.createElement('a');
  const history = document.createElement('div');
  const historyTitle = document.createElement('h2');
  const historyBody = document.createElement('div');
  const teamBody = document.createElement('div');
  const teamTitle = document.createElement('h1');
  const teamText = document.createElement('p');
  const cardFront = document.createElement('div');
  const cardBack = document.createElement('div');

  card.dataset.aos = 'flip-left';

  card.classList.add('card');
  card.classList.add('flipCard');
  cardFront.classList.add('card-face');
  cardFront.classList.add('card-front');
  cardBack.classList.add('card-face');
  cardBack.classList.add('card-back');
  cardBody.classList.add('card-body');
  nameKanji.classList.add('title');
  nameRomaji.classList.add('subtitle');

  let profileImage = new Image();
  profileImage.src = profileShacho;

  title.innerHTML = '代表取締役社長';
  nameKanji.innerHTML = '服部 義一';
  nameRomaji.innerHTML = 'Yoshikazu Hattori';

  cardBody.appendChild(title);
  cardBody.appendChild(nameKanji);
  cardBody.appendChild(nameRomaji);

  twitter.href = 'https://twitter.com/hattori_one';
  const twitterIcon = document.createElement('i');
  twitterIcon.classList.add('fab');
  twitterIcon.classList.add('fa-twitter');
  twitterIcon.dataset.faMask = 'fas fa-circle';
  twitterIcon.dataset.faTransform = 'shrink-5';
  twitter.appendChild(twitterIcon);

  facebook.href = 'https://www.facebook.com/yoshikazu.hattori.56';
  const facebookIcon = document.createElement('i');
  facebookIcon.classList.add('fab');
  facebookIcon.classList.add('fa-facebook-f');
  facebookIcon.dataset.faMask = 'fas fa-circle';
  facebookIcon.dataset.faTransform = 'shrink-3.5 down-1.6 right-1.25';
  facebook.appendChild(facebookIcon);

  blogger.href = 'http://hattori-one.way-nifty.com/';
  const bloggerIcon = document.createElement('i');
  bloggerIcon.classList.add('fab');
  bloggerIcon.classList.add('fa-blogger-b');
  bloggerIcon.dataset.faMask = 'fas fa-circle';
  bloggerIcon.dataset.faTransform = 'shrink-5';
  blogger.appendChild(bloggerIcon);

  if ( verge.mq('(max-width: 768px)') && !verge.mq('(min-resolution: 192dpi), (-webkit-min-device-pixel-ratio: 2)') ) {
    cardFooter.classList.add('card-footer');
    cardFooter.classList.add('fa-lg');
  } else {
    cardFooter.classList.add('card-footer');
    cardFooter.classList.add('fa-2x');
  }
  cardFooter.appendChild(twitter);
  cardFooter.appendChild(facebook);
  cardFooter.appendChild(blogger);

  cardFront.appendChild(profileImage);
  cardFront.appendChild(cardBody);
  cardFront.appendChild(cardFooter);
  card.appendChild(cardFront);
  card.appendChild(cardBack);

  teamTitle.innerHTML = '代表紹介';
  teamText.innerHTML = '1995年1月25歳で起業しまして通信業界で奮闘する中、2006年からは孫正義・重田康光・増田宗昭・孫泰蔵など日本を代表する起業家らとの出会いがありました。そして、次世代の世界をより豊かで明るい未来にしていく為に私達に何が出来るかを再定義しようと考え、2012年に新たにルートワン・パワーを創業しました。';
  teamText.classList.add('team');

  historyTitle.innerHTML = '経歴';

  const datesArray = ['1995年～ 2012年', '2006年～ 2012年', '2008年～ 2012年', '2012年～', '2013年～', '2013年〜 2014年', '2014年～ 2015年', '2015年～ 2016年', '2015年～ 2016年', '2015年～ 2016年']
  const kaishaArray = ['株式会社ルートワン設立<span>代表取締役社長</span>', 'テレコムサービス株式会社<span>代表取締役社長</span>', '株式会社光通信(東証1部上場) <span>上級執行役員</span>', '株式会社ルートワン・パワー <span>代表取締役社長</span>', '日本モバイルカレッジ <span>代表取締役社長</span>', 'UUUM株式会社<span>取締役</span>', 'CCCモバイル株式会社 <span>代表取締役社長</span>', 'CCCモバイルホールディングス株式会社 <span>取締役</span>', 'ふるさとスマホ株式会社 <span>取締役</span>', '株式会社TSUTAYA <span>取締役</span>']

  let historyContainer;
  if (Modernizr.cssgrid) {
    historyContainer = document.createElement('p');
    historyContainer.classList.add('dates');
    datesArray.forEach(function(date, idx) {
      const dateItem = document.createElement('div');
      dateItem.classList.add('date');
      dateItem.classList.add('row-' + (idx + 1));
      dateItem.innerHTML = date;
      historyContainer.appendChild(dateItem);
      const kItem = document.createElement('div');
      kItem.classList.add('kaisha');
      kItem.classList.add('row-' + (idx + 1));
      kItem.innerHTML = kaishaArray[idx];
      historyContainer.appendChild(kItem);
    });
  } else {
    historyContainer = document.createElement('table');
    historyContainer.classList.add('dates');
    datesArray.forEach(function(date, idx) {
      const newRow = document.createElement('tr');
      const dateCell = document.createElement('td');
      const kaishaCell = document.createElement('td');
      dateCell.innerHTML = date;
      kaishaCell.innerHTML = kaishaArray[idx];
      newRow.appendChild(dateCell);
      newRow.appendChild(kaishaCell);
      historyContainer.appendChild(newRow);
    });
  }

  historyBody.classList.add('history-body');
  historyBody.appendChild(historyContainer);
  history.classList.add('history');
  history.appendChild(historyTitle);
  history.appendChild(historyBody);

  teamBody.classList.add('team');
  teamBody.appendChild(teamTitle);
  teamBody.appendChild(teamText);

  if ( verge.mq('(max-width: 768px)') ) {
    cardBack.appendChild(history);
    const button = document.createElement('a');
    button.classList.add('button');
    button.innerHTML = '経歴表示';
    cardFront.appendChild(button);
    card.addEventListener('click', function() {
      this.classList.toggle('flipped');
    });
  } else {
    teamBody.appendChild(history);
  }

  teamBody.dataset.aos = 'fade-left';
  teamBody.dataset.aosDelay = 300;

  element.appendChild(card);
  element.appendChild(teamBody);
  element.classList.add('full-height');
  element.classList.add('shacho');
  element.classList.add('white-bg');
  element.dataset.sectionName = 'Team';
  element.id = 'team';

  return element;
}

function people() {
  const element = document.createElement('section');
  const cards = document.createElement('div');
  cards.dataset.aos = 'zoom-in';
  const infoBox = document.createElement('div');
  infoBox.classList.add('info');
  infoBox.dataset.aos = 'fade-right';
  infoBox.dataset.aosDelay = 300;
  const pageTitle = document.createElement('h1');
  pageTitle.innerHTML = '役員紹介';
  if ( verge.mq('(max-width: 768px)') ) {
    element.appendChild (pageTitle);
  } else {
    infoBox.appendChild (pageTitle);
  }
  cards.classList.add('cards');
  cards.id = 'cards';

  const peopleData = [
    {
      'tag': 'maeda',
      'title': '専務取締役',
      'nameK': '前田 尚士',
      'nameR': 'Hisanori Maeda',
      'bio': '弊社は20年以上携帯電話販売を通じて色々な事業を展開してきました。 主にショップ事業を経験しその経験を生かして色々な事業にチャレンジする、 最終的には事業責任者として独立し社長として運営する。 地域に根付きNO.1の事業を個々が運営する事が弊社のビジョンです。 今後も数多くの事業を作り多くの社長を作っていく事これが我々のミッションです。',
      'photo': './Maeda.jpg'
    },
    {
      'tag': 'yabuuchi',
      'title': '取締役',
      'nameK': '薮内 雅人',
      'nameR': 'Masato Yabuuchi',
      'bio': '我々は20年間リアルショップ運営を通じて、モバイル人材の育成や販売企画を1番の強みとしてきました。 その業界（Route）で、No. 1（One）を、 目指す事業を支援し、新しいPowerを創造する。 これは弊社のミッションですが、ここにある事業とは何も文字通りの事業だけでなく、組織の根幹である人材についても同様であると考えます。常に新しい事にチャレンジし、No.1を目指す人材に支援し、新しいpowerを創造する。 これを常に追いかけ実現できるようにチャレンジし続ける会社でありたいと思います。',
      'photo': './Yabuuchi.jpg'
    },
    {
      'tag': 'kudo',
      'title': '取締役',
      'nameK': '工藤 智大',
      'nameR': 'Tomohiro Kudo',
      'bio': 'これまで新規事業はもちろん、弊社社員の独立企業、他社様と合同の事業立上げ、スタートアップ企業様への支援等、「新しいことへのチャレンジ」には、特に注力して参りました。弊社の強みはモバイル事業に限らず様々な取り組みにチャレンジすることです。その中で私達の仲間も様々なことを経験し、切磋琢磨しながら成長しています。これからも様々な事業、新しいサービスにチャレンジし続けて参ります。',
      'photo': './Kudo.jpg'
    },
    {
      'tag': 'hosokawa',
      'title': '監査役',
      'nameK': '細川 正直',
      'nameR': 'Masanao Hosokawa',
      'other': ['税理士法人細川総合パートナーズ', '代表社員　公認会計士 税理士'],
      'bio': '服部社長以下会社メンバーと付き合いはじめて、11年を超えます。いつもフレキシブルにアメーバー的な動きでかつ、スピードのある対応をされておられます。私は、大手監査法人に就職して以降、証券会社、ベンチャーキャピタル、監査法人、税理士法人、システムハウス等を設立経営してきて、税務・監査・Ｍ＆Ａ・起業家への投資・システム開発等いろいろなかたちでクライアントに経営アドバイスをしてきました。そのすべてを的確に実行し、経営に反映させておられるのが、服部社長率いるルートワン・パワーです。今後も私の今までの経験をすべてそそぎこみ、さらに社会に求められる企業になるよう監査役として業務を遂行するとともに、温かく見守っていきたいと考えています。',
      'photo': './Hosokawa.jpg'
    }
  ];

  const images = require.context('./images/profile', false, /\.jpg$/)

  let lastDelay = 0;

  peopleData.forEach(function(profile) {
    const card = document.createElement('div');
    const cardFront = document.createElement('div');
    const cardBack = document.createElement('div');
    const cardBody = document.createElement('div');
    const cardFooter = document.createElement('div');
    const title = document.createElement('p');
    const nameKanji = document.createElement('h2');
    const nameRomaji = document.createElement('h3');
    const other = document.createElement('p');
    other.classList.add('other');

    card.classList.add('card');
    card.dataset.target = profile['tag'];
    // Necessary for IE10
    $(card).data('target', profile['tag']);
    cardFront.classList.add('card-face');
    cardFront.classList.add('card-front');
    cardBack.classList.add('card-face');
    cardBack.classList.add('card-back');
    cardBody.classList.add('card-body');
    nameKanji.classList.add('title');
    nameRomaji.classList.add('subtitle');

    const imageFile = images(profile['photo']);
    let profilePhoto = new Image();
    profilePhoto.src = imageFile;

    title.innerHTML = profile['title'];
    nameKanji.innerHTML = profile['nameK'];
    nameRomaji.innerHTML = profile['nameR'];

    if ('other' in profile) {
      profile['other'].forEach(function(text) {
        other.innerHTML += text + '<br>';
      });
    }

    cardBody.appendChild(title);
    cardBody.appendChild(nameKanji);
    cardBody.appendChild(nameRomaji);
    cardBody.appendChild(other);

    cardFooter.innerHTML = '&nbsp;';

    cardFront.appendChild(profilePhoto);
    cardFront.appendChild(cardBody);
    cardFront.appendChild(cardFooter);

    card.appendChild(cardFront);
    card.appendChild(cardBack);

    cards.appendChild(card);

    const bio = document.createElement('div');
    bio.classList.add('bio');
    const bioText = document.createElement('p');
    bioText.innerHTML = profile['bio'];
    bio.appendChild(bioText);
    bio.id = profile['tag'];
    infoBox.appendChild(bio);
    if ( verge.mq('(max-width: 768px)') ) {
      cardBack.appendChild(bioText);
      const button = document.createElement('a');
      button.classList.add('button');
      button.innerHTML = '自己紹介表示';
      cardFront.appendChild(button);
      card.classList.add('flipCard');
    }
  });

  element.appendChild(infoBox);
  element.appendChild(cards);
  element.classList.add('full-height');
  element.classList.add('people');
  element.classList.add('white-bg');
  element.id = 'people';

  return element;
}

function mentors() {
  const element = document.createElement('section');
  const cards = document.createElement('div');
  cards.dataset.aos = 'zoom-in';
  const infoBox = document.createElement('div');
  infoBox.classList.add('info');
  infoBox.dataset.aos = 'fade-left';
  infoBox.dataset.aosDelay = 300;
  const pageTitle = document.createElement('h1');
  pageTitle.innerHTML = 'Mentor Message';
  if ( verge.mq('(max-width: 768px)') ) {
    element.appendChild (pageTitle);
  } else {
    infoBox.appendChild (pageTitle);
  }
  cards.classList.add('cards');

  const peopleData = [
    {
      'tag': 'son',
      'link': 'http://mistletoe.co/',
      'nameK': '孫 泰蔵',
      'nameR': 'Taizo Son',
      'profile': '東京大学在学時Yahoo Japan! 立ち上げ統括者として起業。その後、三菱商事とのJV立ち上げ等十数社の企業を設立。ガンホー・オンライン・エンターテインメント株式会社を上場させ、日本のオンラインゲームビジネスの先駆けとして市場を開拓。現在はMOVIDA JAPAN株式会社代表取締役として、ベンチャーのスタートアップを支援している。',
      'message': '服部さんは携帯電話、特にスマートフォンの販売を通じて日本全体にモバイルインターネットを普及させ、世界に先駆けて日本に情報社会を到来させ、素 晴らしい貢献をなさってこられました。彼の大きな目標を必ず実現してみせるという情熱、豊富なアイデア、そしてそのアイデアを実現させる大胆な行動力には 目を見張るものがあり、同じ起業家として僕は服部さんをとても尊敬しています。<br><br>また、個人的にも公私共にお付き合いさせていただいてもう何年も経ちますが、服部さんはいつもすべてのことに全力投球で打ち込んでおられ、一人の人間としてもいつもすごく刺激を受けています。<br><br>そんな服部さんがこの度これまで積み上げてきたものをあえて一旦置いて、一から新たな道を歩んで行くことを決断なさいました。その決断はなかなかで きるものではなく、初めて聞いたときは大変驚きましたが、退路を絶って新しい道を切り開いていく姿はいかにも服部さんらしいなと僕も大いに勇気づけられま した。服部さんが次に何を生み出してくれるのか、これからも大いに注目していきたいと思います。<br><br>服部さんと僕の熱い関係はこれからも何も変わりません。志を同じくする同志として、ともにがんばっていきましょう！これからもどうぞよろしくお願い致します',
      'photo': './Son@2x.png'
    },
    {
      'tag': 'nakagome',
      'link': 'https://www.p-up.jp/',
      'nameK': '中込 正典',
      'nameR': 'Masanori Nakagome',
      'profile': '1966年東京都生まれ。高校卒業後アルバイトをしながらバイクに熱中。1988年、有限会社ピーアップ（現 株式会社ピーアップ）を設立、携帯電話販売店「テルル」を立ち上げる。その後携帯電話を主軸とし180店舗以上のグループを作り上げ、現在は教育、飲食、モータースポーツ等の事業も手がける。',
      'message': '服部さんにはテレコムサービス時代からお世話になっており、ショップが大好きな社長同士ということで意気投合し、いつもいい意味で刺激を受けています。<br><br>そして、服部さんも私もモータースポーツやマラソンなど体を動かすスポーツが大好きで、ビジネスだけでなくプライベートでもご一緒させていただいています。 同じチームでバイクレースに参加したり、ホノルルマラソンに参加したりと、多くの時間を一緒に過ごしていますが、仕事も遊びも全力で取り組む姿勢と、常に 上を目指す情熱、バイタリティ溢れる行動力にはいつも驚かされています。<br><br>そんな服部さんが、今まで培ってきた経験を元に新しく事業を起こされるということは、確実に面白い事が起きるということです。それが今後の携帯電話業界にど んな影響を与えていくのか、むしろ業界全体がひっくり返るようなことをやってくれるのではないかと、私は期待しています。<br><br>服部さんとは、これからもお互いにいい刺激を与え合えるような関係でいたいと思いますし、一緒に面白い事をしてきたいと思います。<br>これからもどうぞよろしくお願い致します。',
      'photo': './Nakagome@2x.png'
    },
    {
      'tag': 'sunada',
      'nameK': '砂田 浩孝',
      'nameR': 'Hirotaka Sunada',
      'profile': '音楽、映像ソフト、楽器販売、インディーズレコードメーカーを持つ株式会社新星堂の再生のリーダーとして様々な事業計画を推進。2013年に当社顧問就任、2015年UUUM株式会社の社外取締役（現任）、2016年より株式会社はせがわの同常務取締役執行役員SC開発部兼商品開発部兼商品部担当として活躍中。',
      'message': '服部さんとのお付き合いは、前職の経営をされている時に合弁会社を共に経営をした時からの関係です。老舗の小売店と閉鎖的な業界に風穴をあける斬新な提案をたくさん頂きました。<br><br>震災の時にはあっという間に関係各所に根回しをしてトラックに乗り込み現地に駆けつける。私達のお店にも救援物資を届けて頂いたり、とにかく、全ての事をポジティブに思考する！どうやったら出来るかを考え続け、かつ誰よりもアクティブてスピーディーに行動をする事に何時も刺激を受けております。<br><br>還暦を超えた私が、服部さんから刺激を受けながら新しい挑戦ができる事は本当に楽しくて仕方が有りません。<br>これからもドンドンやりましょう',
      'photo': './Sunada2x.png'
    }
  ];

  const images = require.context('./images/mentor', false, /\.png$/)

  peopleData.forEach(function(profile) {
    const card = document.createElement('div');
    const cardFront = document.createElement('div');
    const cardBody = document.createElement('div');
    const cardFooter = document.createElement('div');
    const nameKanji = document.createElement('h2');
    const nameRomaji = document.createElement('h3');
    const profileCard = document.createElement('div');

    card.classList.add('card', 'flipCard');
    cardFront.classList.add('card-front');
    cardFront.classList.add('card-face');
    profileCard.classList.add('card-back');
    profileCard.classList.add('card-face');
    card.dataset.target = profile['tag'];
    // Necessary for IE10
    $(card).data('target', profile['tag']);
    cardBody.classList.add('card-body');
    nameKanji.classList.add('title');
    nameRomaji.classList.add('subtitle');
    
    const imageFile = images(profile['photo']);
    let profilePhoto = new Image();
    profilePhoto.src = imageFile;

    nameKanji.innerHTML = profile['nameK'];
    nameRomaji.innerHTML = profile['nameR'];
    cardBody.appendChild(nameKanji);
    cardBody.appendChild(nameRomaji);

    if ('link' in profile) {
      const link = document.createElement('a');
      link.classList.add('button');
      link.href = profile['link'];
      link.innerHTML = 'More';
      link.target = '_blank';
      link.addEventListener('click', function(ev) {
        ev.stopPropagation();
      });
      cardBody.appendChild(link);
    }


    if ( verge.mq('(max-width: 768px)') ) {
      const introText = document.createElement('p');
      introText.innerHTML = profile['profile'];
      const profileText = document.createElement('p');
      profileText.innerHTML = profile['message'];
      profileCard.appendChild(introText);
      profileCard.appendChild(profileText);

      cardFooter.innerHTML = 'メッセージ表示';
      cardFooter.classList.add('card-footer');
    } else {
      const profileNameK = nameKanji.cloneNode(true);
      const profileNameR = nameRomaji.cloneNode(true)
      profileCard.appendChild(profileNameR);
      profileCard.appendChild(profileNameK);
      const profileText = document.createElement('p');
      profileText.innerHTML = profile['profile'];
      profileCard.appendChild(profileText);

      cardFooter.innerHTML = 'プロフィールを表示';
      cardFooter.classList.add('card-footer');
    }

    cardFront.appendChild(profilePhoto);
    cardFront.appendChild(cardBody);
    cardFront.appendChild(cardFooter);
    card.appendChild(cardFront);
    card.appendChild(profileCard);

    card.addEventListener('mouseover', function() {
      const footer = this.getElementsByClassName('card-footer')[0];
      footer.classList.add('large');
      card.addEventListener('mouseout', function() {
        footer.classList.remove('large');
      });
    });


    cards.appendChild(card);

    const bio = document.createElement('div');
    bio.classList.add('bio');
    const bioText = document.createElement('p');
    bioText.innerHTML = profile['message'];
    bio.appendChild(bioText);
    bio.id = profile['tag'];
    infoBox.appendChild(bio);
  });

  element.appendChild(cards);
  element.appendChild(infoBox);
  element.classList.add('full-height');
  element.classList.add('mentors');
  element.classList.add('white-bg');
  element.dataset.sectionName = 'Mentor';
  element.id = 'mentor';

  return element;
}


function company() {
  const element = document.createElement('section');
  element.classList.add('full-height');
  element.classList.add('company');
  element.classList.add('white-bg');
  element.dataset.sectionName = 'Company';
  element.id = 'company';

  const bg = document.createElement('div');
  bg.innerHTML = '&nbsp;';
  bg.dataset.aos = 'slide-right';
  bg.dataset.aosEasing = 'ease-in-bounce';

  const infoData = [
    ['社名', '株式会社ルートワン・パワー'],
    ['代表取締役', '服部 義一'],
    ['専務取締役', '前田 尚士'],
    ['取締役', '薮内 雅人'],
    ['取締役', '工藤 智大'],
    ['監査役', '細川 正直<small>（税理士法人 細川総合パートナーズ）</small>'],
    ['創業日', '1995年10月16日'],
    ['設立日', '2010年3月3日'],
    ['資本金', '5億円（資本準備金等含む）'],
    ['株主構成', '服部 義一　51.6％<br>カルチュア･コンビニエンス･クラブ㈱ 33.6％<br>株式会社 光通信 (東証1部上場)14.9％']
  ];

  const info = document.createElement('div');
  info.dataset.aos = 'zoom-in';
  info.dataset.aosDelay = 300;
  const infoHeader = document.createElement('h1');
  infoHeader.innerHTML = 'Company.';
  const infoSub = document.createElement('h2');
  infoSub.innerHTML = '会社概要';
  info.appendChild(infoHeader);
  info.appendChild(infoSub);

  const infoTable = document.createElement('table');
  infoData.forEach(function(item) {
    const infoRow = document.createElement('tr');
    const infoKey = document.createElement('td');
    const infoValue = document.createElement('td');

    infoKey.innerHTML = item[0];
    infoKey.classList.add('key');
    infoValue.innerHTML = item[1];

    infoRow.appendChild(infoKey);
    infoRow.appendChild(infoValue);

    infoTable.appendChild(infoRow);
  });
  info.appendChild(infoTable);

  element.appendChild(bg);
  element.appendChild(info);

  return element;
}

function group() {
  const groupData = [
    {
      'name': '株式会社 ルートワン',
      'hp': 'http://www.route-one.jp/',
      'logo': './RouteOne_White@2x.png',
      'color': 'Blue'
    },
    {
      'name': 'レイン・バード株式会社',
      'hp': 'https://www.rainbird.co.jp/',
      'logo': './Rainbird_White@2x.png',
      'color': 'Purple'
    },
    {
      'name': '株式会社 Gifbit',
      'hp': 'https://www.gifbit.co.jp/',
      'logo': './Gifbit_White@2x.png',
      'color': 'Yellow'
    },
    {
      'name': '株式会社アニマリアル',
      'hp': 'http://animareal.com/',
      'logo': './AnimaReal_White@2x.png',
      'color': 'Black'
    },
    {
      'name': '日本モバイルカレッジ株式会社',
      'hp': 'https://www.mobile-college.jp/',
      'logo': './MobileCollege_White@2x.png',
      'color': 'Green'
    },
    {
      'name': 'ワンアレイラ',
      'hp': 'http://1-aleira.com/index.html',
      'logo': './OneAleira.png',
      'color': 'OneAleira'
    },
  ];

  const images = require.context('./images/group', false, /\.png$/);

  const element = document.createElement('section');
  element.classList.add('full-height');
  element.classList.add('white-bg');
  element.classList.add('group');
  element.dataset.sectionName = 'Group';
  element.id = 'group';

  let grid;

  if (Modernizr.cssgrid) {
    grid = document.createElement('div');
    grid.classList.add('columns');
    groupData.forEach(function(data) {
      let gridItem = document.createElement('a');
      let gridImage = new Image()
      gridImage.src = images(data['logo']);
      gridImage.alt = data['name'];
      gridItem.appendChild(gridImage);
      gridItem.href = data['hp'];
      gridItem.classList.add(data['color']);
      grid.appendChild(gridItem);
    });
  } else {
    grid = document.createElement('table');
    grid.classList.add('columns');
    let counter = 0;
    let row;
    groupData.forEach(function(data) {
      if ( counter % 3 === 0 ) {
        row = document.createElement('tr');
        grid.appendChild(row);
      }
      const cell = document.createElement('td');
      const link = document.createElement('a');
      let gridImage = new Image();
      gridImage.src = images(data['logo']);
      gridImage.alt = data['name'];
      link.appendChild(gridImage);
      link.href = data['hp'];
      link.classList.add(data['color']);
      cell.appendChild(link);
      row.appendChild(cell);
      counter++;
    });
  }

  element.appendChild(grid);

  return element;
}

function map() {
  const element = document.createElement('section');
  const container = document.createElement('div');
  container.classList.add('container');
  element.classList.add('full-height');
  element.classList.add('white-bg');
  element.classList.add('access');
  element.id = 'access';
  element.dataset.sectionName = 'Access';

  const header = document.createElement('h1');
  header.innerHTML = 'Access.';

  const tokyoCard = document.createElement('div');
  const tokyoCardFace = document.createElement('div');
  const tokyoCardBody = document.createElement('div');
  const tokyoCardFooter = document.createElement('div');

  tokyoCardFooter.classList.add('card-footer');
  tokyoCardBody.classList.add('card-body');
  tokyoCardFace.classList.add('card-face');
  tokyoCard.classList.add('card');
  tokyoCard.appendChild(tokyoCardFace);
  tokyoCardFace.appendChild(tokyoCardBody);
  tokyoCardFace.appendChild(tokyoCardFooter);

  const osakaCard = tokyoCard.cloneNode(true);
  const osakaCardFace = osakaCard.getElementsByClassName('card-face')[0];

  GoogleMapsLoader.KEY = 'AIzaSyBSRJQNhGIc2A9RQ1Kf6MVmqoXhczmBxzk';
  const tokyo = {lat: 35.675192, lng: 139.669003};
  const tokyoMapCenter = {lat: 35.675675, lng: 139.669003};
  const osaka = {lat: 34.681187, lng: 135.496196};
  const osakaMapCenter = {lat: 34.681675, lng: 135.496196};

  const tokyoMap = document.createElement('div');
  const osakaMap = document.createElement('div');
  tokyoMap.classList.add('map');
  osakaMap.classList.add('map');

  GoogleMapsLoader.load(function(google) {
    let tokyomap = new google.maps.Map(tokyoMap, {
      zoom: 16,
      center: tokyoMapCenter,
      styles: mapStyle,
    });

    let osakamap = new google.maps.Map(osakaMap, {
      zoom: 16,
      center: osakaMapCenter,
      styles: mapStyle,
    });

    var sasazuka = new google.maps.Marker({
      position: tokyo,
      map: tokyomap,
      title: 'Tokyo Office'
    });

    var osakaoffice = new google.maps.Marker({
      position: osaka,
      map: osakamap,
      title: 'Osaka Office'
    });

    var tokyoinfo = new google.maps.InfoWindow({
      content: 'Tokyo Office'
    });

    var osakainfo = new google.maps.InfoWindow({
      content: 'Osaka Office'
    });

    tokyoinfo.open(tokyomap, sasazuka);
    osakainfo.open(osakamap, osakaoffice);
  });

  tokyoCardFace.insertBefore(tokyoMap, tokyoCardBody);
  osakaCardFace.insertBefore(osakaMap, osakaCardFace.childNodes[0]);

  tokyoCardBody.innerHTML = "<h2>東京本社</h2><p>〒151-0073　東京都渋谷区<br>笹塚2-7-9  MSK笹塚<br>TEL  03-6300-5407(代)<br>FAX 03-6300-5408</p>";
  const tokyoMapLink = document.createElement('a');
  tokyoMapLink.classList.add('button');
  tokyoMapLink.href = 'https://goo.gl/maps/sASDy4SM3Wq';
  tokyoMapLink.innerHTML = 'マップで表示';
  tokyoCardFooter.appendChild(tokyoMapLink);

  const osakaCardBody = osakaCardFace.childNodes[1];
  const osakaCardFooter = osakaCardFace.childNodes[2];

  osakaCardBody.innerHTML = '<h2>大阪支社</h2><p>〒550-0011　大阪市西区阿波座<br>1-5-12　ACDC02ビル (5F)<br>TEL 06-7878-6000(代)<br>FAX 06-7878-6777</p>';
  const osakaMapLink = tokyoMapLink.cloneNode(true);
  osakaMapLink.href = 'https://goo.gl/maps/U9DdMSHEg2x';
  osakaCardFooter.appendChild(osakaMapLink);
  
  container.appendChild(tokyoCard);
  container.appendChild(osakaCard);

  element.appendChild(header);
  element.appendChild(container);
  element.appendChild(footer());
  return element;
}

function footer() {
  const element = document.createElement('section');
  element.classList.add('inter');
  let left = new Image();
  left.src = r1plogo;
  if( !verge.mq('(min-resolution: 192dpi), (-webkit-min-device-pixel-ratio: 2), (max-width: 768px)') ) {
    left.addEventListener('load', e => {
      e.target.style.width = (e.target.naturalWidth / 2) + "px";
      e.target.style.height = (e.target.naturalHeight / 2) + "px";
    });
  } else {
    left.addEventListener('load', e => {
      e.target.style.width = (e.target.naturalWidth / 4) + "px";
      e.target.style.height = (e.target.naturalHeight / 4) + "px";
    });
  }

  const right = document.createElement('div');
  const copy = document.createElement('p');
  copy.innerHTML = 'COPYRIGHT © ROUTEONE POWER';
  const rightLink = document.createElement('p');
  rightLink.innerHTML = 'All Rights Reserved';

  const link = document.createElement('a');
  link.innerHTML = 'Privacy Policy';
  link.classList.add('modal-button');
  link.dataset.target = 'privacy';

  if ( verge.mq('(max-width: 768px)') ) {
    right.appendChild(copy);
    rightLink.innerHTML += ' | ';
    rightLink.appendChild(link);
    right.appendChild(rightLink);
  } else {
    right.appendChild(link);
    right.innerHTML += '<p>' + copy.innerHTML + ' ' + rightLink.innerHTML + '</p>';
  }

  element.appendChild(left);
  element.appendChild(right);

  return element;
}

function privacy() {
  const element = document.createElement('div');
  element.classList.add('modal');
  element.id = 'privacy';

  const bg = document.createElement('div');
  bg.classList.add('modal-background');
  element.appendChild(bg);

  const content = document.createElement('div');
  content.classList.add('modal-content');
  element.appendChild(content);

  const close = document.createElement('div');
  close.classList.add('modal-close', 'is-large');
  element.appendChild(close);

  content.innerHTML = '<p>平成24年8月1日制定<br>株式会社ルートワン・パワー　プライバシーポリシー</p><p>株式会社 ルートワン・パワー（以下「弊社」）は、以下のとおり個人情報保護方針を定め、個人情報保護の仕組みを構築し、全従業員に個人情報保護の重要性の認識と取組みを徹底させることにより、個人情報の保護を推進致します。</p><h3>個人情報の管理</h3><p>弊社は、弊社が保有する個人情報を正確かつ最新の状態に保ち、個人情報への不正アクセス・紛失・破損・改ざん・漏洩などを防止するため、セキュリ ティシステムの維持・管理体制の整備・社員教育の徹底等の必要な措置を講じ、安全対策を実施し個人情報の厳重な管理を行ないます。</p><h3>個人情報の利用目的</h3><p>(1) 弊社が保有する個人情報は、以下に掲げる弊社事業活動の遂行並びに関連するアフターサービス、商品・サービスのご案内及びアンケート調査の実施等に必要な範囲に限り利用します。また、個人情報の取得に当たっては、適法かつ公正な手段を用います。<br>•個人及び法人のお客様：電気通信事業にかかわるご案内、契約・申し込み処理、請求収納、サービスの提供、アフターサービス、商品・サービスの改善および収集時に明示もしくは同意いただいた目的のため。<br>•お取引先様：業務遂行及び契約に伴う連絡、諸手続きのため<br>•採用応募者および従業員：採用選考のため、およびその他従業員情報管理規程に定める目的のため<br>•その他全般：個人情報の開示等の求めに応ずるため、および当社施設の安全管理のため<br>(2) 弊社は、業務委託により個人情報を取得する場合、委託された業務の範囲内において取り扱うとともに厳正なる管理を行います。</p><h3>個人情報の第三者への開示・提供の禁止</h3><p>弊社は、次のいずれかに該当する場合を除き、個人情報を第三者に開示いたしません。<br>(1) ご本人の同意がある場合<br>(2) お客様が希望されるサービスを行なうために当社が業務を委託する業者に対して開示する場合<br>(3) 法令に基づき開示することが必要である場合</p><h3>個人情報の安全対策</h3><p>弊社は、個人情報の正確性及び安全性確保のために、セキュリティに万全の対策を講じます。</p><h3>法令、規範の遵守と見直し</h3><p>弊社は、保有する個人情報に関して適用される日本の法令、その他規範を遵守するとともに、本ポリシーの内容を適宜見直し、その改善に努めます。</p>';

  return element;
}

function setUpModals() {

  function getAll(selector) {
    return Array.prototype.slice.call(document.querySelectorAll(selector), 0);
  }

  // Modals

  var rootEl = document.documentElement;
  var $modals = getAll('.modal');
  var $modalButtons = getAll('.modal-button');
  var $modalCloses = getAll('.modal-background, .modal-close, .modal-card-head .delete, .modal-card-foot .button');

  if ($modalButtons.length > 0) {
    $modalButtons.forEach(function ($el) {
      $el.addEventListener('click', function () {
        var target = $el.dataset.target;
        var $target = document.getElementById(target);
        rootEl.classList.add('is-clipped');
        $target.classList.add('is-active');
      });
    });
  }

  if ($modalCloses.length > 0) {
    $modalCloses.forEach(function ($el) {
      $el.addEventListener('click', function () {
        closeModals();
      });
    });
  }

  document.addEventListener('keydown', function (event) {
    var e = event || window.event;
    if (e.keyCode === 27) {
      closeModals();
      closeDropdowns();
    }
  });

  function closeModals() {
    rootEl.classList.remove('is-clipped');
    $modals.forEach(function ($el) {
      $el.classList.remove('is-active');
    });
  }
}

if (Modernizr.flexbox && Modernizr.flexwrap) {
  // we are good
} else {
  flexibility(document.body);
}

const wrapper = document.createElement('div');
wrapper.classList.add('wrapper');
document.body.appendChild(wrapper);
wrapper.appendChild(navigation());
wrapper.appendChild(home());
wrapper.appendChild(intro());
wrapper.appendChild(companies());
wrapper.appendChild(mission());
wrapper.appendChild(power());
wrapper.appendChild(shacho());
wrapper.appendChild(timeline());
wrapper.appendChild(people());
wrapper.appendChild(mentors());
wrapper.appendChild(company());
wrapper.appendChild(group());
wrapper.appendChild(map());
wrapper.appendChild(privacy());
setUpModals();

AOS.init({
  disable: 'mobile'
});

let scrollifyConfig = {
  section : ".full-height",
  easing: 'easeOutQuint',
  interstitialSection: '.inter',
  overflowScroll: true,
  scrollSpeed: 900,
  standardScrollElements: '.modal',
  before: function(index, sections) {
    $( '.flipped' ).removeClass('flipped');
  }
}

if ( !verge.mq('(max-width: 768px)') ) {
  $.scrollify(scrollifyConfig);
}


(function(factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery', 'hammerjs'], factory);
    } else if (typeof exports === 'object') {
        factory(require('jquery'), require('hammerjs'));
    } else {
        factory(jQuery, Hammer);
    }
}(function($, Hammer) {
    function hammerify(el, options) {
        var $el = $(el);
        if(!$el.data("hammer")) {
            $el.data("hammer", new Hammer($el[0], options));
        }
    }

    $.fn.hammer = function(options) {
        return this.each(function() {
            hammerify(this, options);
        });
    };

    // extend the emit method to also trigger jQuery events
    Hammer.Manager.prototype.emit = (function(originalEmit) {
        return function(type, data) {
            originalEmit.call(this, type, data);
            $(this.element).trigger({
                type: type,
                gesture: data
            });
        };
    })(Hammer.Manager.prototype.emit);
}));

(function($) {
  $.fn.rotateSlider = function(opt) {
    var $this = this,
        itemClass = opt.itemClass || 'card',
        arrowClass = opt.arrowClass || 'arrow',
        $item = $this.find('.' + itemClass),
        $arrow = $this.find('.' + arrowClass),
        itemCount = $item.length;

    const defaultIndex = 0;

    changeIndex(defaultIndex);

    $(this).hammer({enable: verge.mq('(max-width: 768px)')}).bind('swipeleft', function(ev) {
      const nowIndex = $item.index($this.find('.now'));
      if(nowIndex == itemCount - 1) {
        changeIndex(0);
      } else {
        changeIndex(nowIndex + 1);
      }
    });
    $(this).hammer({enable: verge.mq('(max-width: 768px)')}).bind('swiperight', function(ev) {
      const nowIndex = $item.index($this.find('.now'));
      if(nowIndex == 0) {
        changeIndex(itemCount - 1);
      } else {
        changeIndex(nowIndex - 1);
      }
    });

    $item.on('click', function() {
      const nowIndex = $item.index($this.find('.now'));
      if($(this).hasClass('next')) {
        if(nowIndex == itemCount - 1) {
          changeIndex(0);
        } else {
          changeIndex(nowIndex + 1);
        }
      } else if($(this).hasClass('prev')) {
        if(nowIndex == 0) {
          changeIndex(itemCount - 1);
        } else {
          changeIndex(nowIndex - 1);
        }
      } else if($(this).hasClass('now') && $(this).hasClass('flipCard')) {
        $(this).toggleClass('flipped');
      }
    });
        
    $arrow.on('click', function() {
      const action = $(this).data('action'),
            nowIndex = $item.index($this.find('.now'));
    
      if(action == 'next') {
        if(nowIndex == itemCount - 1) {
          changeIndex(0);
        } else {
          changeIndex(nowIndex + 1);
        }
      } else if (action == 'prev') {
        if(nowIndex == 0) {
          changeIndex(itemCount - 1);
        } else {
          changeIndex(nowIndex - 1);
        }
      }
    });
    
    function changeIndex (nowIndex) {
      $this.find('.now').removeClass('now');
      $this.find('.next').removeClass('next');
      $this.find('.prev').removeClass('prev');
      $this.find('.current').removeClass('current');
      $this.find('.flipped').removeClass('flipped');
      if(nowIndex == itemCount - 1) {
        $item.eq(0).addClass('next');
      }
      if(nowIndex == 0) {
        $item.eq(itemCount - 1).addClass('prev');
      }

      $item.each(function(index) {
        if(index == nowIndex) {
          $item.eq(index).addClass('now');
          let target = $item.eq(index).data('target')
          const $target = $('#' + target);
          $target.addClass('current');
        }
        if(index == nowIndex + 1) {
          $item.eq(index).addClass('next');
        }
        if(index == nowIndex - 1) {
          $item.eq(index).addClass('prev');
        }
      });
    }
  };
})($);

$('#people').rotateSlider({});
$('#mentor').rotateSlider({});

const mapStyle = [
  {
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#ebe3cd"
      }
    ]
  },
  {
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#523735"
      }
    ]
  },
  {
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#f5f1e6"
      }
    ]
  },
  {
    "featureType": "administrative",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#c9b2a6"
      }
    ]
  },
  {
    "featureType": "administrative.land_parcel",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#dcd2be"
      }
    ]
  },
  {
    "featureType": "administrative.land_parcel",
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "administrative.land_parcel",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#ae9e90"
      }
    ]
  },
  {
    "featureType": "landscape.natural",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#dfd2ae"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#dfd2ae"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.text",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#93817c"
      }
    ]
  },
  {
    "featureType": "poi.business",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#a5b076"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels.text",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#447530"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#f5f1e6"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#fdfcf8"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#f8c967"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#e9bc62"
      }
    ]
  },
  {
    "featureType": "road.highway.controlled_access",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e98d58"
      }
    ]
  },
  {
    "featureType": "road.highway.controlled_access",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#db8555"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#806b63"
      }
    ]
  },
  {
    "featureType": "transit.line",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#dfd2ae"
      }
    ]
  },
  {
    "featureType": "transit.line",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#8f7d77"
      }
    ]
  },
  {
    "featureType": "transit.line",
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#ebe3cd"
      }
    ]
  },
  {
    "featureType": "transit.station",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#dfd2ae"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#b9d3c2"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#92998d"
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/index.js